import { Injectable } from '@angular/core';

import { TableColumnDef } from './table-column-def';

@Injectable()
export class TableHelperService {
    constructor() {}

    public buildSearchUrl(
        filterStr: string,
        tableInfo: Array<TableColumnDef>
    ): string {
        if (filterStr === undefined || filterStr === null || filterStr === '') {
            return null;
        }

        const urlSearchString = Array<string>();

        const tokens = filterStr.match(/\w+|"[^"]+"/g);

        let searchString = '';

        // jezeli mamy zdefiniowana kolumne do ogolnego wyszukiwania to szukamy po niej,
        // w przeciwnym wypadku po wszystkich kolumnach zdefiniowanych jako filtr
        const column = tableInfo.find((c) => c.isGeneralSearchColumn === true);
        if (column === undefined || column === null) {
            tokens.forEach((token) =>
                this.buildEntryMultipleColumnSearch(
                    token,
                    tableInfo,
                    urlSearchString
                )
            );

            searchString = `(${urlSearchString.join(' or ')})`;
        } else {
            tokens.forEach((token) =>
                this.buildEntrySingleColumnSearch(
                    token,
                    tableInfo,
                    urlSearchString
                )
            );

            searchString = `(${urlSearchString.join(' and ')})`;
        }

        return searchString;
    }

    private buildEntryMultipleColumnSearch(
        token: string,
        tableInfo: Array<TableColumnDef>,
        urlSearchString: string[]
    ): string {
        const tokenAsNumber = Number(token);
        let tokenAsString = token;
        if (token.charAt(0) === '"') {
            tokenAsString = token.replace(/\"/g, '');
        }

        tableInfo.map((column: TableColumnDef) => {
            if (column.columnDef !== undefined) {
                if (column.type === 'number') {
                    if (tokenAsNumber !== undefined && !isNaN(tokenAsNumber)) {
                        urlSearchString.push(
                            `(${(column.filterNameProp) ? column.filterNameProp : column.columnDef} eq ${tokenAsNumber})`
                        );
                    }
                } else {
                    urlSearchString.push(
                        `contains(${(column.filterNameProp) ? column.filterNameProp : column.columnDef},'${tokenAsString}')`
                    );
                }
            }
        });

        return `(${urlSearchString.join(' or ')})`;
    }

    private buildEntrySingleColumnSearch(
        token: string,
        tableInfo: Array<TableColumnDef>,
        urlSearchString: string[]
    ): string {
        const tokenAsNumber = Number(token);
        let tokenAsString = token;
        if (token.charAt(0) === '"') {
            tokenAsString = token.replace(/\"/g, '');
        }

        const column = tableInfo.find((c) => c.isGeneralSearchColumn === true);
        if (column === undefined || column === null) {
            return '';
        }

        if (column.columnDef !== undefined) {
            if (column.type === 'number') {
                if (tokenAsNumber !== undefined && !isNaN(tokenAsNumber)) {
                    urlSearchString.push(
                        `(${(column.filterNameProp) ? column.filterNameProp : column.columnDef} eq ${tokenAsNumber})`
                    );
                }
            } else {
                urlSearchString.push(
                    `contains(${(column.filterNameProp) ? column.filterNameProp : column.columnDef},'${tokenAsString}')`
                );
            }
        }

        return `(${urlSearchString.join(' or ')})`;
    }
}
